"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HasLength_1 = require("../../shared/HasLength");
const HasSize_1 = require("../../shared/HasSize");
class HasNumberOfElementsValidator {
    constructor(numberOfElements) {
        this.numberOfElements = numberOfElements;
    }
    isValid(input) {
        if (HasLength_1.hasLength(input)) {
            return input.length === this.numberOfElements;
        }
        else if (HasSize_1.hasSize(input)) {
            return input.size === this.numberOfElements;
        }
        else {
            return false;
        }
    }
}
exports.HasNumberOfElementsValidator = HasNumberOfElementsValidator;
//# sourceMappingURL=HasNumberOfElementsValidator.js.map